import React, { useContext } from "react";
import i18next from "../../../i18n";
import { Icon, Switch, RootContext, useIsMobile } from "easemob-chat-uikit";
import classNames from "classnames";
import { DEMO_VERSION, UIKIT_VERSION } from "../../../config";
const About = (props: { onBack?: () => void }) => {
  const { onBack } = props;
  const isMobile = useIsMobile();
  const prefixCls = "user-info";

  const context = useContext(RootContext);
  const { theme } = context;
  const themeMode = theme?.mode;
  return (
    <div
      className={classNames("setting-personal", {
        "setting-personal-dark": themeMode === "dark",
        "mobile-fullwidth": isMobile,
      })}
    >
      <header className="setting-personal-header">
        {isMobile && (
          <Icon
            type="ARROW_LEFT"
            width={24}
            height={24}
            onClick={onBack}
          ></Icon>
        )}
        {i18next.t("about")}
      </header>
      <main className="setting-personal-main">
        <section className="setting-personal-content">
          <div className="user-info-content">
            <div className={`${prefixCls}-content-item`}>
              <div
                className={`${prefixCls}-content-item-box`}
                style={{ cursor: "default" }}
              >
                <span>{i18next.t("demoVersion")}</span>
                <div>{DEMO_VERSION}</div>
              </div>
            </div>
            <div className={`${prefixCls}-content-item`}>
              <div
                className={`${prefixCls}-content-item-box`}
                style={{ cursor: "default" }}
              >
                <span>{i18next.t("uikitVersion")}</span>
                <div>{UIKIT_VERSION}</div>
              </div>
            </div>
            <div className={`${prefixCls}-content-item`}>
              <div
                className={`${prefixCls}-content-item-box`}
                style={{ cursor: "default" }}
              >
                <span>{i18next.t("officialWebsite")}</span>
                <div>
                  <a
                    href="https://www.huanxin.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    www.huanxin.com
                  </a>
                </div>
              </div>
            </div>
            <div className={`${prefixCls}-content-item`}>
              <div
                className={`${prefixCls}-content-item-box`}
                style={{ cursor: "default" }}
              >
                <span>{i18next.t("hotline")}</span>
                <div>
                  <a href="tel:4006221776"></a>400-622-1776
                </div>
              </div>
            </div>
            <div className={`${prefixCls}-content-item`}>
              <div
                className={`${prefixCls}-content-item-box`}
                style={{ cursor: "default" }}
              >
                <span>{i18next.t("businessDevelopment")}</span>
                <div>
                  <a href="mailto:bd@easemob.com">bd@easemob.com</a>
                </div>
              </div>
            </div>
            <div className={`${prefixCls}-content-item`}>
              <div
                className={`${prefixCls}-content-item-box`}
                style={{ cursor: "default" }}
              >
                <span>{i18next.t("channelCooperation")}</span>
                <div>
                  <a href="mailto:qudao@easemob.com">qudao@easemob.com</a>
                </div>
              </div>
            </div>
            <div className={`${prefixCls}-content-item`}>
              <div
                className={`${prefixCls}-content-item-box`}
                style={{ cursor: "default" }}
              >
                <span>{i18next.t("issues")}</span>
                <div>
                  <a href="mailto:issues@easemob.com">issues@easemob.com</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
